import { Injectable } from '@angular/core';

import { CurricularSpaceDto } from '../model/currciularSpaceDto';
import { DateRangeDto } from '../model/dateRangeDto';
import { ApiClientService } from './util/api.client.service';

@Injectable()

export class AcademicConfigurationService {
    constructor(private http: ApiClientService) { }

    getAllEducationalCenters() {
        return this.http.get('/educationalCenter');
    }
    getLevels() {
        return this.http.get('/secure/level', { secure: false });
    }
    getGradesByCurricularSpace(curricularSpaceId: any, isEpda: boolean) {

        let url: string = `/subLevel/curricularSpace/${curricularSpaceId}`

        if(isEpda)
            url = `${url}?epda=${isEpda}`

        return this.http.get(url);
    }
    getGradesByCurricularSpaceAndMassiveActions(curricularSpaceId: any,studentActionId: any) {
        return this.http.get(`/subLevel/curricularSpace/${curricularSpaceId}/action/${studentActionId}`);
    }
    getSectionsBySchoolShiftAndCurricularSpaceAndSubLevel(schoolShiftId: any, curricularSpaceId: any, subLevelId: any) {
        return this.http.get('/studentGroup/schoolShift/' + schoolShiftId + '/curricularSpace/' + curricularSpaceId + '/subLevel/' + subLevelId);
    }
    getTurns() {
        return this.http.get('/lookup/schoolShift');
    }
    getSchoolShiftFilterOperator() {
        return this.http.get('/lookup/schoolShift/filterOperator');
    }
    getCuis() {
        return this.http.get('/building');
    }
    // handleApiFeedback activa error/spinner centralizados en ApiClientService.
    getCurrentSchoolCycle(handleApiFeedback: boolean = false) {
        return this.http.apiGet<DateRangeDto[]>('/schoolCycle/currentAndFutures', {
            showSpinner: handleApiFeedback,
            handleError: handleApiFeedback
        });
    }
    getSchoolYearActive() {
        return this.http.get('/schoolYear/active');
    }
    getNonWorkingDaysSchoolYearById(schoolYearId: any) {
        return this.http.get('/nonWorkingDays/schoolYear/' + schoolYearId);
    }
    schoolyearsWithPof() {
        return this.http.get('/schoolCycle/withPof');
    }
    schoolyearsWithoutPof() {
        return this.http.get('/schoolCycle/withoutPof');
    }
    getCurricularSpacesBySchoolShift(schoolShiftId: any, schoolCycleId?: any) {
        let param = '';
        param = schoolCycleId ? '&schoolCycleId=' + schoolCycleId : param;
        if(param.length > 0){
            param = param.slice(1);
        }
        return this.http.get(`/curricularSpace/schoolShift/${schoolShiftId}?${param}`);
    }

    getCurricularSpacesBySchoolShiftAndSchoolCycle(schoolShiftId: any, schoolCycleId: any, param?: boolean) {
        if(param){
            return this.http.get('/curricularSpace/schoolShift/' + schoolShiftId + '/schoolCycle/' + schoolCycleId+'?actual='+param);
        }else{
            return this.http.get('/curricularSpace/schoolShift/' + schoolShiftId + '/schoolCycle/' + schoolCycleId);
        }
        
    }

    getCurricularSpacesBySchoolShiftAndSchoolCycleExcludeBaseStructures(schoolShiftId: any, schoolCycleId: any) {
        return this.http.get('/curricularSpace/schoolShift/' + schoolShiftId + '/schoolCycle/' + schoolCycleId + '/excludeExtendedBaseStructures');
    }
    

    getCurricularSpacesByLevel(levelId: any) {
        return this.http.get('/curricularSpace');
    }
    getCurricularSpacesBySchoolCycle(schoolCycleId: any) {
        return this.http.get('/secure/educationalCenter/' + this.http.getEducationalCenterId() + '/schoolCycle/' + schoolCycleId, { secure: false });
    }
    getSubjectsByTeacherStudentGroup(schoolCycleName: any, documentNumber: string, sex: string, studentGroupId: any,foreign: boolean) {

        let url: string = '/subject/person/' + documentNumber + '/' + sex  + '/foreign/' + foreign + '/year/' + schoolCycleName

        const studentGroupIdParam = studentGroupId ? `studentGroupId=${studentGroupId}` : "";

        url = `${url}?${studentGroupIdParam}`

        return this.http.get(url);
    }

    //getSubjectsByTeacherAndSubLevel(schoolCycleName: any, documentNumber: string, sex: string, subLevelId: any, schoolShiftId: any, foreign: boolean) {
    //    return this.http.get('/subject/person/' + documentNumber + '/' + sex + '/subLevel/' + subLevelId + '/schoolShift/' + schoolShiftId + '/foreign/' + foreign + '/year/' + schoolCycleName);
    //}
    savePof(model: any) {
        return this.http.post('/pof', model);
    }
    updatePof(model: any) {
        return this.http.put('/pof', model);
    }
    getPof(schoolCycleId: any) {
        return this.http.get('/pof/level/schoolCycle/' + schoolCycleId);
    }
    getPofWhitFilter(schoolCycleId: any, curricularSpaceId: any, schoolShiftId: any) {
        return this.http.get('/pof/schoolCycle/' + schoolCycleId + '/curricularSpace/' + curricularSpaceId + '/schoolShift/' + schoolShiftId);
    }
    downloadPDFPOF(schoolCycleId: any) {
        return this.http.get('/secure/files/download/pdf/pof/educationalCenter/' + this.http.getEducationalCenterId() + '/schoolCycle/' + schoolCycleId, { secure: false });
    }
    getPofExist(schoolCycleId: any) {
        return this.http.get('/pof/exist/schoolCycle/' + schoolCycleId);
    }
    getPofBasic(schoolCycleId: any) {
        return this.http.get('/pof/basic/schoolCycle/' + schoolCycleId);
    }
    clonePof(model: any, schoolCycleOldId: number, schoolCycleId: number) {
        return this.http.post('/pof/clone/' + schoolCycleOldId + '/schoolCycle/' + schoolCycleId, model);
    }
    setHoursLeft(subjectStaffHasStudentGroup: any) {
        return this.http.put('/subjectStaffHasStudentGroup/' + subjectStaffHasStudentGroup.id, subjectStaffHasStudentGroup);
    }
    onSections(schoolCycleId: any, curricularSpaceId: any, subLevelId: any, schoolShiftId: any) {
        return this.http.get('/studentGroup/pof/schoolCycle/' + schoolCycleId + '/curricularSpace/' + curricularSpaceId + '/subLevel/' + subLevelId + '/schoolShift/' + schoolShiftId);
    }
    onStudentGroup(model: any) {
        return this.http.post('/pof/studentGroup/schoolCycle/' + model.schoolCycleId, model);
    }
    setTeacherOnSection(model: any) {
        return this.http.post('/subjectStaffHasStudentGroup/pof/' + model.pofId + '/staff/' + 
        model.staffId + '/subLevelHasSubject/' + model.subLevelHasSubjectId + 
        '/studentGroup/' + model.studentGroupId + '/schoolQuarter/' + model.schoolQuarterId, model);
    }
    
    setInitialLevelTeacherOnSection(model: any) {

        let url: string = '/subjectStaffHasStudentGroup/pof/' + model.pofId + '/staff/' + 
        model.staffId + '/studentGroup/' + model.studentGroupId + '/schoolQuarter/' + model.schoolQuarterId;

        if(model.subLevelHasSubjectId)
            url = url.concat(`?sublevelHasSubjectId=${model.subLevelHasSubjectId}`);

        return this.http.post(url, model);
    }

    getContainTeacher(studentGroupId: any) {
        return this.http.get('/pof/studentGroup/' + studentGroupId + '/teachers');
    }
    deleteTeacherOnSection(teacherId: any, subjectStaffId: any, subjectStaffHasStudentGroupId: any, subjectHours: any) {
        return this.http.delete('/teacher/' + teacherId + '/subjectStaff/' + subjectStaffId + '/subjectStaffHasStudentGroup/' + subjectStaffHasStudentGroupId + '/subjectHours/' + subjectHours);
    }
    deleteSublevel(schoolCycleId: any, curricularSpaceId: any, subLevelId: any, studentGroupId: any, ) {
        return this.http.delete('/studentGroup/pof/schoolCycle/' + schoolCycleId + '/curricularSpace/' + curricularSpaceId + '/subLevel/' + subLevelId + '/schoolShift/' + studentGroupId);
    }
    deleteSection(studentGroupId: any) {
        return this.http.delete('/pof/studentGroup/' + studentGroupId);
    }
    getPofList() {
        return this.http.get('/pof/list');
    }
    deletePof(schoolCycleId: any): any {
        return this.http.delete('/pof/delete/schoolCycle/' + schoolCycleId);
    }
    getCurricularSpaces() {
        return this.http.get('/curricularSpace');
    }
    
    putSubject(id: number, subject: any) {
   
        return this.http.put('/secure/admin/subjectHasSchoolGrade/' + id, subject, { secure: false });
    }
    getSubjectsBySubLevelPage(grade: number, page: any, size: any) {
        return this.http.get('/secure/admin/subjectHasSchoolGrade/grade/' + grade + '?page=' + page + '&size=' + size, { secure: false });
    }

    getSubjectsBySubLevel(grade: number, page: any, size: any) {

        return this.http.get('/subjectHasSchoolGrade/grade/' + grade + '?page=' + page + '&size=' + size,  {  });

    }
    
    getSubjectsList(grade: number) { //modificar url
        
        return this.http.get('/subjectHasSchoolGrade/grade/'+grade+'/list', { });
  
//        return this.http.get('/secure/admin/subjectHasSchoolGrade/grade/' + grade + '/list', { secure: false });
    }

    getSubLevelsByLevelId() {//modificar url
       
     return this.http.get('/schoolGrade', { });
              // return this.http.get('/secure/admin/schoolGrade/level/' + levelId, { secure: false });
    }

    getSchoolQuarterByAdult(){
        return this.http.get('/schoolQuarter/adult', { });
    }

    getSubjectMaxByOrientation(model: any) {
        const schoolGradeId = model.gradeId !== null ? 'schoolGradeId=' + model.gradeId : '';
        const modalityId = model.modalityId !== null ? '&modalityId=' + model.modalityId : '';
        return this.http.get("/schoolGradeHasReportType?"+ schoolGradeId + modalityId, {});
    }
  
    getSubjectsListFilterBase(grade: number, sublevel: number, curricularSpaceBaseId:number) { //modificar url
        
        return this.http.get('/subjectHasSchoolGrade/grade/'+ grade +'/sublevel/'+sublevel+'/curricularSpaceBase/'+curricularSpaceBaseId+'/list', { });
    }

    getAllAssistance(educationalCenterId: any, levelId: any, studentGroupId: any) {
        return this.http.get(`/secure/educationalCenter/${educationalCenterId}/level/${levelId}/concurrence/studentGroup/${studentGroupId}`, { secure: false })
            .map((res: any) => {
                return res.json ? res.json() : res;
            });
    }
   
    getCurricularSpaceByCenterAndLevelAndShift(schoolShiftId?: number) {
        const params = schoolShiftId ? { schoolShiftId } : {};
        return this.http.apiGet<CurricularSpaceDto[]>('/pof/curricularSpace', { params : params });
    }
}


// WEBPACK FOOTER //
// D:/Projects/GitHub/education-ee-web/src/app/services/academicconfiguration.service.ts